<template>
	<Col
		:span="24"
		:offset="0"
		:xl="{ span: 12 }"
	>
		<Card :title="$t('account.passwordChangeCardTitle')">
			<Form
				:model="formState"
				name="basic"
				:label-col="{ span: 12 }"
				:wrapper-col="{ span: 12 }"
				:colon="false"
				autocomplete="off"
			>
				<FormItem :wrapper-col="{ span: 24 }">
					<TypographyText type="secondary">{{ $t('account.passwordChangeHelpText') }}</TypographyText>
				</FormItem>
				<FormItem
					:label="$t('account.oldPassword')"
					v-bind="validateInfos.oldPassword"
				>
					<InputPassword v-model:value="formState.oldPassword" @keyup.enter="onSubmit"/>
				</FormItem>

				<FormItem
					:label="$t('account.password1')"
					v-bind="validateInfos.password1"
				>
					<InputPassword v-model:value="formState.password1" @keyup.enter="onSubmit"/>
				</FormItem>

				<FormItem
					:label="$t('account.password2')"
					v-bind="validateInfos.password2"
				>
					<InputPassword v-model:value="formState.password2" @keyup.enter="onSubmit"/>
				</FormItem>
			</Form>
			<template #actions>
				<Button
					type="primary"
					@click.prevent="onSubmit"
					:loading="isLoading"
				>
					{{ $t('account.passwordButtonLabel') }}
				</Button>
			</template>
		</Card>
	</Col>
</template>

<script>
import { reactive, ref } from 'vue';
import { Col, Card, Button, Form, FormItem, InputPassword, TypographyText, message } from 'ant-design-vue';

const useForm = Form.useForm;

import { useI18n } from 'vue-i18n'

import Api from '@/api/Api';

import { showErrorMessage } from '@/components/common/errorMessage';

export default {
	components: {
		Col, Card, Button, Form, FormItem, InputPassword, TypographyText,
	},
	setup() {
		const { t } = useI18n();
		const formState = reactive({
			oldPassword: '',
			password1: '',
			password2: '',
		});
		const validatePass = async (_rule, value) => {
			if (value === '') {
				return Promise.reject(t('account.messages.repeatPassword'));
			}
			if (value !== formState.password1) {
				return Promise.reject(t('account.messages.checkPassword'));
			}
			return Promise.resolve();
		};
		const rulesRef = reactive({
			oldPassword: [{ required: true, message: t('account.messages.enterOldPassword') }],
			password1: [{ required: true, message: t('account.messages.enterNewPassword') }],
			password2: [{ validator: validatePass }],
		});
		const {
			validate,
			validateInfos,
		} = useForm(formState, rulesRef);
		const isLoading = ref(false);
		const onSubmit = () => {
			validate().then(() => {
				isLoading.value = true;
				Api.changePassword(
					formState.oldPassword,
					formState.password1,
					() => {
						isLoading.value = false;
						message.success(t('account.messages.passwordSuccess'));
					},
					error => {
						isLoading.value = false;
						let errors = error.response.data;
						if (errors) {
							showErrorMessage(errors);
						}
					},
				);
			}).catch(() => {
				isLoading.value = false;
			});
		};
		return {
			formState,
			validateInfos,
			isLoading,
			onSubmit,
		};
	},
}
</script>
